// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PicLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/PicLeftOutlined";
import AntdIcon from '../components/AntdIcon';

var PicLeftOutlined = function PicLeftOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PicLeftOutlinedSvg
  }));
};

PicLeftOutlined.displayName = 'PicLeftOutlined';
export default React.forwardRef(PicLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PicLeftOutlined.js
// module id = 1561
// module chunks = 0